window.addEventListener('load', function () {
    if (typeof google === "undefined") {
        return null;
    }

    const mapElements = document.querySelectorAll('.cite-wordpress-theme-map');

    for (var i = 0; i < mapElements.length; i++) {
        const element = mapElements[i];

        const lat = parseFloat(element.dataset.lat);
        const lng = parseFloat(element.dataset.lng);
        const zoom = parseFloat(element.dataset.zoom);

        const location = {
            lat: lat,
            lng: lng
        }

        const map = new google.maps.Map(element, {
            zoom: zoom,
            center: location,
            disableDefaultUI: true,
            zoomControl: true,
            clickableIcons: false
        });

        const icon = {
            url: STYLESHEET_DIRECTORY_URI + '/resources/assets/dist/img/map-marker.svg',
            scaledSize: new google.maps.Size(40, 54),
            origin: new google.maps.Point(0, 0),
            anchor: new google.maps.Point(20, 54)
        };

        const marker = new google.maps.Marker({
            position: location,
            map: map,
            icon: icon,
        });
    }
});